module.exports = __webpack_public_path__ + "img/signup-carousel-fifth.2506757c.png";